import axios from "axios";
import store from "../redux/store"; // adjust to your actual path
import { logout } from "../redux/features/authSlice";
import { setExpiredModalOpen } from "../redux/features/expiredModalSlice";

const isProduction = true;

// Base URLs
export const baseURL = isProduction
  ? "https://saigon-star-server-26.vercel.app"
  : "http://localhost:5015";

// export const baseURL = "http://localhost:5010";
export const publicClient = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_PUBLIC_KEY,
  },
});

export const privateClient = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to attach token to privateClient
privateClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("actkn");
  if (token) {
    // Ensure headers exist
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

privateClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("🔴 AXIOS INTERCEPTOR TRIGGERED", error?.response?.status);

      store.dispatch(logout());

      store.dispatch(setExpiredModalOpen(true));
      localStorage.removeItem("actkn");
    }

    return Promise.reject(error);
  },
);
